// extracted by mini-css-extract-plugin
export var currencyInput = "_m6-1";
export var currencySymbol = "_m6-0";